<template>
    <div >
        <el-form label-position="right" ref="formdata" label-width="110px" class="mt31" :model="formdata" size='large' inline>
            <el-form-item label="平台" prop="type">
                <el-select v-model="formdata.type" clearable placeholder="请选择">
                    <el-option v-for="item in platform_options" :key="item.klpmid" :label="item.platform_name" :value="item.klpmid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="达人名称" prop="klurid">
                <el-select v-model="formdata.klurid" filterable clearable remote :remote-method="getKolList" placeholder="请选择">
                    <el-option v-for="item in kol_options" :key="item.klurid" :label="item.nickname" :value="item.klurid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否需要寄样" prop="is_send_sample">
                <el-select v-model="formdata.is_send_sample" clearable placeholder="请选择">
                    <el-option v-for="item in isSendSampleArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合作状态" prop="status">
                <el-select v-model="formdata.status" clearable placeholder="请选择">
                    <el-option v-for="item in status_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form label-width="110px">
            <el-form-item>
                <el-button type="primary" @click="cpxDealList" size='medium'>搜索</el-button>
                <el-button @click="resetForm" size='medium'>重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list_data" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
            <el-table-column label="达人信息" min-width="380">
                <template slot-scope="scope">
                    <div class="flex">
                        <div>
                            <img class="page-goods-img" :src="scope.row.head_portrait" alt="头像" />
                            <div v-if="scope.row.cxinklid"><el-tag type="primary" class="tag" size="mini" >意向达人</el-tag></div>
                        </div>
                        <div>
                        <div>平台：{{scope.row.type_name}}</div>
                        <div >昵称：{{scope.row.nickname}}
                            <el-popover v-if='!scope.row.home_link' placement="top-start" trigger="click" content="该达人主页还在完善哦">
                                <span class='page-pointer z-14' slot="reference">查看达人主页</span>
                            </el-popover>
                            <el-link class="fz-14" v-if="(scope.row.long_url||scope.row.home_link)" :href="scope.row.long_url?scope.row.long_url:scope.row.home_link" target="_blank" type="primary" :underline="false">查看达人主页</el-link>
                        </div>
                        <div>粉丝数：{{scope.row.fans?scope.row.fans:'暂无'}} <el-link class="fz-14" :underline="false" type="primary" v-if='scope.row.luopan_id&&(scope.row.type==1||scope.row.type==2)' @click="goFans(scope.row)">查看粉丝画像</el-link></div>
                        <div>推荐时间：{{scope.row.create_time}}</div>

                    </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="合作形式及刊例报价" width='350'>
                <template slot-scope="scope">
                    <div class="flex">
                      <div class="p-color-man w80" v-if='scope.row.base_price!=""'>基础报价</div>
                      <div class="w_right">
                        <div v-for='(item,index) in scope.row.base_price' :key='index'>
                            <div v-if='item.cps>0||item.cpt_20s>0|item.cpt_60s>0||item.cpt_single>0||item.cpt_special>0||item.cpt_other>0||item.cpa>0||item.cpc>0'>
                                <div>下单途径：
                                    <span v-if='item.cooperation_method==1'>星图</span>
                                    <span v-if='item.cooperation_method==2'>合同</span>
                                    <span v-if='item.cooperation_method==3'>海南个人</span>
                                </div>
                                <div>合作报价：
                                    <div v-if='item.cps>0' class="flex">
                                        <div v-if='item.cps_addition > 0'>CPT:￥{{item.cps_addition}}元  佣比{{item.cps_commission}}%</div>
                                        <div v-if='item.cps_addition <=0' >CPS:佣比{{item.cps_commission}}%</div>
                                    </div>
                                    <div v-if='item.cpt_20s>0' class="flex">
                                        CPT+短视频20s: ￥{{item.cpt_20s_after_tax}}元  佣比：{{item.cpt_20s_commission}}% 
                                    </div>
                                    <div v-if='item.cpt_60s>0' class="flex">
                                        CPT+短视频60s: ￥{{item.cpt_60s_after_tax}} 元 佣比：{{item.cpt_60s_commission}}% 
                                    </div>
                                    <div v-if='item.cpt_single>0' class="flex">
                                        CPT+直播单坑: ￥{{item.cpt_single_after_tax}}元  佣比：{{item.cpt_single_commission}}%
                                    </div>
                                    <div v-if='item.cpt_special>0' class="flex">
                                        CPT+直播专场: ￥{{item.cpt_special_after_tax}}元 佣比：{{item.cpt_special_commission}}%  坑位数：{{item.cpt_special_place}}
                                    </div>
                                    <div v-if='item.cpt_other>0' class="flex">
                                        CPT+其他(图文等):￥{{item.cpt_other_after_tax}}元 佣比：{{item.cpt_other_commission}}%
                                    </div>
                                    <div v-if='item.cpa>0' class="flex">
                                        CPA:￥{{item.cpa_after_tax}}元 
                                    </div>
                                    <div v-if='item.cpc>0' class="flex">
                                        CPC:￥{{item.cpc_after_tax}}元
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="p-color-man w80" v-if='scope.row.combination_price!=""'>组合报价</div>
                      <div class="w_right">
                        <div v-for='(item,index) in scope.row.combination_price' :key='index+"a"'>
                            <div v-if='item.check_status==1'>
                                <div class="flex">
                                    <div class="p-color-danger">组合报价{{index+1}}：</div>
                                </div>
                                <div class="flex">
                                    <div>下单途径：
                                    <span v-if='item.cooperation_method==1'>星图</span>
                                    <span v-if='item.cooperation_method==2'>合同</span>
                                    <span v-if='item.cooperation_method==3'>海南个人</span>
                                    </div>
                                </div>
                                <div>合作报价：
                                    <div v-if='item.cps>0'>{{item.cps}} x  CPS</div>
                                    <div v-if='item.cpt_20s>0'>{{item.cpt_20s}} x  CPT+短视频20s</div>
                                    <div v-if='item.cpt_60s>0'>{{item.cpt_60s}} x CPT+短视频60s</div>
                                    <div v-if='item.cpt_single>0'>{{item.cpt_single}} x CPT+直播单坑</div>
                                    <div v-if='item.cpt_special>0'>{{item.cpt_special}} x CPT+直播专场</div>
                                    <div v-if='item.cpt_other>0'>{{item.cpt_other}} x CPT+其他(图文等)</div>
                                    <div v-if='item.cpa>0'>{{item.cpa}} x CPA</div>
                                    <div v-if='item.cpc>0'>{{item.cpc}} x CPC</div>
                                </div>
                                <div>打包价格：￥{{item.combination_after_tax}}元</div>
                            </div>
                        </div> 
                      </div>  
                    </div> 
                </template>
            </el-table-column>
            <el-table-column label="状态" width='180'>
                <template slot-scope="scope">
                <div>
                    状态：
                    <span class="p-color-succ" v-if="scope.row.status==1">待添加至合作名单
                    <el-tooltip placement="top" v-if="scope.row.delete_remark">
                        <div slot="content" class="w-500">{{scope.row.delete_remark}}</div>
                        <i class="p-color-danger el-icon-question"></i>
                    </el-tooltip>
                    </span>
                    <span class="p-color-succ" v-if="scope.row.status==2">待上传达人报价
                    <el-tooltip placement="top" v-if="scope.row.reject_reason">
                        <div slot="content" class="w-500">{{scope.row.reject_reason}}</div>
                        <i class="p-color-danger el-icon-question"></i>
                    </el-tooltip>
                    </span>
                    <span class="p-color-succ" v-if="scope.row.status==3">待确认报价</span>
                    <span class="p-color-succ" v-if="scope.row.status==6">待交付</span>
                    <span class="p-color-succ" v-if="scope.row.status==7">待效果回传</span>
                    <span class="p-color-succ" v-if="scope.row.status==8">效果数据待审核</span>
                    <span class="p-color-succ" v-if="scope.row.status==9">合作完成</span>
                    <span class="p-color-danger" v-if="scope.row.status==10">终止合作
                    <el-tooltip placement="top">
                        <div slot="content">商单项目已被终止</div>
                        <i class="p-color-danger el-icon-question"></i>
                    </el-tooltip>
                    </span>
                    <span class="p-color-danger" v-if="scope.row.status==11">已拒绝</span>
                </div>
                <el-tooltip placement="top" v-if="scope.row.delete_remark">
                    <div slot="content" class="w-500">{{scope.row.delete_remark}}</div>
                    <div class="lin3">拒绝原因：{{scope.row.delete_remark}}</div>
                </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" >
                <template slot-scope="scope">
                    <el-button class="btn" type='text' size='large'  @click="showKolIsSelect(scope.row,2)" v-if="(scope.row.status==1||scope.row.status==11)">选择</el-button>
                    <el-button class="btn" type='text' size='large'  @click="showKolIsSelect(scope.row,1)" v-if="scope.row.status==1">拒绝</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
        <!-- 选择达人/拒绝达人 -->
        <!-- {{kol_select_info.kol_isSelect_flag}} -->
        <kolisselect v-if='kol_select_info.kol_isSelect_flag' :kol_select_info='kol_select_info' @kolIsSelectClose='kolIsSelectClose'></kolisselect>
        <!-- 查看合作形式及报价 -->
        <lookcooperationoffer v-if='cooperation_flag' :look_cooperation='look_cooperation' @closeLookCooperation='closeLookCooperation'></lookcooperationoffer>
        <!-- 达人采访记录 -->
        <mediaquestions v-if='media_questions_obj.media_questions_flag' :media_questions_obj='media_questions_obj'></mediaquestions>
        <!-- 粉丝画像 -->
        <portraitfans v-if="isfans" :fansObj="fansObj" @closeMask ='isfans = false'></portraitfans>
    </div>

  

</template>
<script>
import apiUrl from "@/config/api.js";
import utils from "@/utils/util.js";
import pagePagination from "@/components/page_pagination.vue"
import lookcooperationoffer from "@/components/cpx/look_cooperation_offer.vue";
import mediaquestions from "@/components/cpx/media_questions.vue";
import kolisselect from "@/components/cpx/kol_is_select.vue";
import portraitfans from "@/views/my/portrait_fans.vue"
export default {
    name: "cpx_kol_selected",
    components: {
        pagePagination,
        lookcooperationoffer,
        mediaquestions,
        kolisselect,
        portraitfans
    },
    props: {
        cxorid:'',
    },
    data() {
        return {
            isfans: false,
            fansObj: {},
            api: {
                cpxDealList: "home/cpxDealList", 
                getKolPlatformList: "home/getKolPlatformList", 
                getKolUserList: "home/getKolUserList", 
            },
            list_data: [],
            pageData: {
                count: 0,
                page: 1,
                offset: 20
            },
            formdata: {
                adid: '',
                type: '',
                status: '',
                is_send_sample: '',
                kol_status: 2,
            },
            platform_options: [],//达人平台
            kol_options:[],//达人昵称列表
            status_arr: [
                {value:'1',label:'待添加至合作名单'},
                {value:'11',label:'已拒绝'},
            ],
            isSendSampleArr:[
                { label: "是", value: "2" },
                { label: "否", value: "1" },
            ],
            cooperation_flag:false,//查看合作形式及报价
            look_cooperation:'',
            is_select:false,
            kol_select_info:{
                kol_isSelect_flag:false,
                type:'',
                cxdlid:'',
            },
            media_questions_obj: {
                media_questions_flag: false,
                klurid: ""
            }
            
        };
    },
    created() {
        this.cpxDealList();
        this.getKolPlatformList()
    },
   
    methods: {
        //初始化数据
        cpxDealList() {
            let _this = this;
            let data = this.formdata;
            data.page = this.pageData.page;
            data.offset = this.pageData.offset;
            data.cps = data.cooperation_type==1 ? 2:''
            data.cpt_recommended = data.cooperation_type==2 ? 2:''
            data.cpt_goods = data.cooperation_type==3 ? 2:''
            data.cpa = data.cooperation_type==4 ? 2:''
            data.cpc = data.cooperation_type==5 ? 2:''
            data.promote_video = data.promote_type==1 ? 2:''
            data.promote_live = data.promote_type==2 ? 2:''
            data.promote_live_special = data.promote_type==4 ? 2:''
            data.promote_other = data.promote_type==3 ? 2:''
            data.kol_status = 2
            data.orid = _this.cxorid
            this.$http({
                method: "GET",
                url: _this.api.cpxDealList,
                params: data
            }).then(res => {
                if (res.code == 1) {
                   
                    let key_arr= ['cps','cpt_20s','cpt_60s','cpt_single','cpt_special','cpt_other','cpa','cpc']
                    let arr = res.data
                    arr.forEach((item)=>{
                        item.base_price.forEach((i)=>{
                            key_arr.forEach((k)=>{
                                if(k!='cps'&&k!='cpa'&&k!='cpc'&&k!='cpt_other'){
                                    if(i.cooperation_method==2){
                                        i[`${k}_after_tax`] =utils.floatAccAdd(utils.floatAccMul(i[`${k}_addition`]/100,i[`${k}_money`]),i[`${k}_money`]).toFixed(0)
                                    }else{
                                        i[`${k}_after_tax`] =utils.floatAccAdd(utils.floatAccMul(i[`${k}_addition`]/100,i[`${k}_after_tax`]),i[`${k}_after_tax`]).toFixed(0)
                                    }
                                }
                                if(k=='cpa' || k=='cpc' || k=='cpt_other'){
                                    if(i.cooperation_method==2){
                                        i[`${k}_after_tax`] = utils.floatAccAdd(i[`${k}_addition`]?i[`${k}_addition`]:'',i[`${k}_money`]?i[`${k}_money`]:'')
                                    }else{
                                        i[`${k}_after_tax`] = utils.floatAccAdd(i[`${k}_addition`]?i[`${k}_addition`]:'',i[`${k}_after_tax`]?i[`${k}_after_tax`]:'')
                                    }
                                }

                            })
                        })
                        item.combination_price.forEach((i)=>{
                            if(i.check_status==1){
                                if(i.cooperation_method==2){
                                    i.combination_after_tax =utils.floatAccAdd(utils.floatAccMul(i.combination_price_addition/100,i.combination_price),i.combination_price).toFixed(0)
                                }else{
                                    i.combination_after_tax =utils.floatAccAdd(utils.floatAccMul(i.combination_price_addition/100,i.combination_after_tax),i.combination_after_tax).toFixed(0)
                                }
                            }

                        })

                    })

                     _this.list_data = arr
                    _this.pageData.count = res.count
                } else {
                    this.$message.warning(res.msg);
                }
            })
        },
        
        showKolIsSelect(row,type){
            this.kol_select_info.kol_isSelect_flag=true
            this.kol_select_info.type = type
            this.kol_select_info.cxdlid = row.cxdlid
        },
        kolIsSelectClose(data){
            this.cpxDealList()
        },
        // 查看合作形式及报价
        getCooperation(row){
            this.cooperation_flag=true
            this.look_cooperation={
                cxdlid:row.cxdlid,
                klurid:row.klurid,
            }
        },
        closeLookCooperation(){
        this.cooperation_flag=false
        },
        // 达人列表
        getKolList(name){
            let _this = this;
            _this
                .$http({
                method: "GET",
                url: this.api.getKolUserList,
                params: { nickname: name},
                hideloading: true
                })
                .then(res => {
                    if (res.code == 1) {
                        _this.kol_options = res.data;
                    } else {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(err => {
                console.log(err);
            });
        },
    
    
        //重置搜索项目
        resetForm() {
            this.$refs.formdata.resetFields();
        },
        // 分页改变
        pageChange(page, pageSize){
            this.pageData.page = page;
            this.pageData.offset = pageSize;
            this.cpxDealList();
        },
        // 导出
        exportOut(){
            let data = this.formdata
            data.cps = data.cspta==1 ? 2:''
            data.cpt_recommended = data.cspta==2 ? 2:''
            data.cpt_goods = data.cspta==3 ? 2:''
            data.cpa = data.cspta==4 ? 2:''
            data.cpc = data.cspta==5 ? 2:''
            data.promote_video = data.promote_type==1 ? 2:''
            data.promote_live = data.promote_type==2 ? 2:''
            data.promote_live_special = data.promote_type==4 ? 2:''
            data.promote_other = data.promote_type==3 ? 2:''
            data.kol_status = 2
            data.orid = this.cpx_info_parameter.formdata.cxorid
            delete data.cspta
            delete data.promote_type
            let open_url = apiUrl.cpxDealList + "?auth_token=" +this.$http.getAuth("auth_token") + "&export=1&d=" + new Date().getTime();
            for (let key in data) {
                if (data[key]) {
                open_url += `&${key}=${data[key]}`;
                }
            }
            window.open(open_url, "_blank");
        },
        goFans(row) {
            this.isfans = true;
            this.fansObj = row;
            // let data={...row}
            // data.luopan_id=row.luopan_id
            // this.$router.push({
            //     path: "/my/orderlist/portrait_fans",
            //     query: data
            // })
        },
        // 达人平台列表
        getKolPlatformList(){
            this.$http({
                method: "GET",
                url: this.api.getKolPlatformList,
                params: {}
            }).then(res => {
                if (res.code == 1) {
                this.platform_options = res.data.list
                }else{
                this.$message.error(res.msg)
                }
            });
        },


        // 媒介10问
        goMideaQuestion(row){
            this.media_questions_obj.klurid=row.klurid;
            this.media_questions_obj.media_questions_flag=true;
            
        },
      
    }
};
</script>

<style scoped>
.w192{
    width: 192px;
}
.mt-20{
    margin-top: 20px;
}
.mt31{
    margin-top: 31px;
}
.flex{
  display: flex;
}
.fz-14{
    font-size: 14px;
    margin-top: -3px;
}
.tag{
    margin-right: 5px;
}
.btn {
  margin:  0;
  display: block;
}
.img {
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 10px;
}
.w-500{
  max-width: 500px;
}
.lin3{
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.w80{
    width: 70px;
}
.w_right{
    width: 250px;
}

</style>